import React from 'react';

export default function NotFound (): React.ReactElement {
  return (
    <section className="section">
      <div className="container">
        <h1>Not found</h1>
      </div>
    </section>
  );
}